import {useQuery, UseQueryResult} from 'react-query'
import {AddressDetails, Coordinate} from '@hconnect/tuc-processes/shipToCreation'
import {api} from '../../../App.global'
import {ADDRESS_QUERY_STALE_TIME_MS} from '../constants'

export type ResolveAddressParams = {
  searchText?: string
  country: string
  magicKey?: string
}

export type LocationBoundaries = {
  minLongitude: number
  minLatitude: number
  maxLongitude: number
  maxLatitude: number
}

export type ResolveAddressResponse = {
  addresses: {
    location: Coordinate
    addressDetails: AddressDetails
    locationBoundaries: LocationBoundaries
  }
}

export const resolveAddress = async (
  params: ResolveAddressParams
): Promise<ResolveAddressResponse> => {
  const config = {params}
  const response = await api.get('/address/resolve', config)
  const {data} = response
  return data
}

export const useResolveAddress = (
  params: ResolveAddressParams
): UseQueryResult<ResolveAddressResponse, Error> => {
  return useQuery<ResolveAddressResponse, Error>({
    queryKey: [
      'resolveAddress',
      {
        ...params
      }
    ],
    queryFn: () => resolveAddress(params),
    staleTime: ADDRESS_QUERY_STALE_TIME_MS,
    cacheTime: ADDRESS_QUERY_STALE_TIME_MS,
    enabled: (!!params.searchText || !!params.magicKey) && !!params.country
  })
}
